import React from "react";
import messionBg from "../../images/messionBg.png";
import { useState } from "react";

function Mission() {
  const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    // handle subscription logic
    console.log("Subscribed with email:", email);
    setEmail("");
  };

  return (
    <section className="relative w-full max-w-[1200px] mt-10 mx-auto rounded-xl overflow-hidden xl:h-[410px]">
      {/* Gradient background with overlay */}

      {/* Background pattern image (flipped) */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${messionBg})`,
        }}
      />

      {/* Main content */}
      <div className="relative w-full flex flex-col xl:flex-row items-start xl:items-end justify-between gap-10 xl:gap-0 px-6 sm:px-8 py-10 xl:p-0 xl:absolute xl:left-[63.5px] xl:top-1/2 xl:-translate-y-1/2 xl:w-[1063px]">
        {/* Left column */}
        <div className="w-full xl:w-[476px] flex flex-col gap-6 xl:gap-20">
          <div className="flex flex-col gap-6">
            <h2 className="font-medium text-[28px] sm:text-[34px] lg:text-[40px] xl:text-[48px] leading-[100%] text-white">
              Join the Mission for Zero Emissions.
            </h2>
            <p className="text-[16px] lg:text-[17px] xl:text-[18px] text-[#FAFAFA] xl:mb-10">
              Subscribe to receive intelligence reports on carbon markets,
              regulatory updates from Nigeria, and technical insights from the
              CloseCarbon ecosystem.
            </p>
          </div>
        </div>

        {/* Right column */}
        <div className="w-full xl:w-[399px] flex flex-col gap-6">
          {/* Email input */}
          <div className="flex flex-row items-center gap-2.5 w-full h-[58px] px-4 sm:px-8 py-4 bg-[rgba(137,137,137,0.7)] border border-white rounded-lg">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-[#E4E7EC] flex-shrink-0"
            >
              <path
                d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 6L12 13L2 6"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter you email address"
              className="w-full min-w-0 bg-transparent text-white placeholder-[#E4E7EC] font-medium text-[14px] outline-none"
            />
          </div>

          {/* Subscribe button */}
          <button
            onClick={handleSubscribe}
            className="flex flex-row justify-center items-center w-full h-[61px] px-4 sm:px-8 py-4 bg-white border border-[#E4E7EC] rounded-lg"
          >
            <span className="font-medium text-[15px] sm:text-[18px] lg:text-[22px] xl:text-3xl leading-[120%] tracking-[-0.02em] text-[#0D924F] text-center">
              Subscribe to our newsletter{" "}
            </span>
          </button>
        </div>
      </div>

      {/* Footer note */}
      <p className="relative xl:absolute xl:left-[64px] xl:bottom-[49px] px-6 sm:px-8 xl:p-0 pb-10 xl:pb-0 text-sm leading-[17px] text-[#FAFAFA]">
        By joining, you agree to our data integrity standards and environmental
        protocols.
      </p>
    </section>
  );
}

export default Mission;